angular.module('IndicatorTree').factory('IndicatorTreeService', function () {
  'use strict';

  /**
   * category Tree constructor
   * @param {Object} categories the categories
   * @returns {Array}
   */
  function buildCategoryTree(categories) {
    var categoriesObject = angular.copy(categories);
    return buildTreeFromFlatCategories(categoriesObject);
  }

  /**
   * IndicatorTree constructor
   * @param {Object} categories the categories
   * @returns {Array}
   */
  function buildIndicatorTree(categories) {
    var categoriesObject = angular.copy(categories);
    return filterAndSortTree(buildTreeFromFlatCategories(categoriesObject));
  }

  /**
   * Builds a tree from a flat categoriesObject
   *
   * @param {Object} categoriesObject the categories
   * @returns {Array} the tree
   */
  function buildTreeFromFlatCategories(categoriesObject) {
    var tree = [];
    for(var categoryUid in categoriesObject) {
      if(categoriesObject.hasOwnProperty(categoryUid)) {
        var category = categoriesObject[categoryUid];
        category.title = category.name;
        category.class = "category";

        var parentUid = category.parent;
        if(parentUid && categoriesObject.hasOwnProperty(parentUid)) {
          var parent = categoriesObject[parentUid];
          if(!parent.items) {
            parent.items = [];
          }
          parent.items.push(category);
          parent.items.sort(compareItemsForSorting); // sorting is done here to prevent from walking the complete tree for sorting
        } else {
          tree.push(category); // rootcategories
        }
      }
    }

    return tree;
  }

  /**
   * filter for null values
   * @param {*} item item to check
   * @returns {boolean}
   */
  function filterNull(item) {
    return item != null;
  }

  /**
   * filter empty categories and sort by 'compareItemsForSorting'
   * @param {Array} tree the tree to filter
   * @returns {Array}
   */
  function filterAndSortTree(tree) {
    for(var i= 0; i < tree.length; i++) {
      var node = tree[i];
      if(node.class === 'category') {
        if(!angular.isArray(tree[i].items)) {
          tree[i] = null; // remove category without items
        } else {
          var subItems = filterAndSortTree(node.items);
          if(subItems.length === 0) {
            tree[i] = null; // remove category with all items filtered out
          } else {
            tree[i].items = subItems;
          }
        }
      }
    }

    return tree.filter(filterNull).sort(compareItemsForSorting);
  }

  /**
   * comparefunction for sorting tree items
   * categories are sorted first, after that it`s alphabetically
   *
   * @param {Object} a first item
   * @param {Object} b second item
   * @returns {number}
   */
  function compareItemsForSorting(a, b) {
    if(a.class === 'category' && b.class !== 'category') {
      return -1;
    }
    if(a.class !== 'category' && b.class === 'category') {
      return 1;
    }
    var sortResult = 0;
    if(a.hasOwnProperty('sorting') && a.sorting != null && b.hasOwnProperty('sorting') && b.sorting != null) {
      sortResult = a.sorting - b.sorting;
    }
    if(angular.isNumber(sortResult) && sortResult !== 0) {
      return sortResult;
    } else {
      return a.title.localeCompare(b.title);
    }
  }

  return {

    /**
     * Returns the Indicator-Tree
     * @param indicators
     * @param categories
     * @param indicatorSets
     * @returns {IndicatorTree}
     */
    buildIndicatorTree: buildIndicatorTree,
    buildCategoryTree: buildCategoryTree
  }
});
